import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useGroupActions } from 'hooks'

import { useGetGroupQuery } from 'store/api/yay/group'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const ConfirmBoxJoinGroupBeforeAction = ({
  onClose,
  isActive,
  data,
}: {
  onClose: () => void
  isActive: boolean
  data: {
    groupId: number
  }
}) => {
  const { t } = useTranslation()

  const { onJoinGroup } = useGroupActions()
  const groupRes = useGetGroupQuery(
    { groupId: data?.groupId?.toString?.() },
    {
      skip: !data?.groupId,
    }
  )

  const [__isLoading, __isLoadingSet] = useState(false)

  return (
    <ConfirmBoxBasic
      isActive={isActive}
      onClose={onClose}
      onOk={() => {
        __isLoadingSet(true)

        onJoinGroup(groupRes?.data)
          .then((res: any) => {
            if (res?.['data']?.status == 'success') {
              onClose?.()
            }
          })
          .finally(() => {
            __isLoadingSet(false)
          })
      }}
      onCancel={onClose}
      title={t('confirm_box_join_group_before_action.title')}
      content={t('confirm_box_join_group_before_action.content')}
      loading={__isLoading}
      cancelText={t('confirm_box_join_group_before_action.close')}
      confirmButtonText={t('confirm_box_join_group_before_action.confirm')}
    />
  )
}

export default ConfirmBoxJoinGroupBeforeAction
